// extracted by css-extract-rspack-plugin
export default {"EmbeddingFooter":"V2yPW"};